import React from 'react';
import ConfirmationForm from '../ConfirmationForm';
import { statusMeta, subjectLabel } from './timeEntryCard';

// Renderer for the track-time result: the same cards as the preflight form, flagged with each save's outcome
// and with no action button (this is the outcome, not a prompt). Reuses ConfirmationForm with confirm off.
export default function TrackTimeResult({ data, fields, isLast }) {
  return (
    <ConfirmationForm
      data={data}
      fields={fields}
      isLast={isLast}
      itemLabel="entries"
      omitFields={['status']}
      statusFor={statusMeta}
      labelFor={subjectLabel}
      canConfirm={false}
    />
  );
}
